
import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal, NgbModalRef, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { IssueWebHistory } from '../../../models';
import { IssueWebService, SettingsService } from '../../../services';
import { modalLarge } from '../../../shared/modules/dialogOptions';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@Component({
    selector: 'app-issue-action',
    templateUrl: './issue-action.component.html',
    styleUrls: ['./issue-action.component.scss']
})

export class IssueActionComponent implements OnInit {
    model: any = {};
    photoSrc: any;
    isSending: boolean;
    isLoading: boolean = false;
    IssueType2: string = "Issue Type 2";
    IssueType1: string = "Issue Type 1";
    IssueType3: string = "Issue Type 3";
    currentUser: any;
    IsConfirmed: boolean = false;
    modalReference: NgbModalRef;
    isCloseIssue: boolean;
    issueWebHistoryModel: IssueWebHistory = new IssueWebHistory();
    isCreatingLog: boolean = false;
    issueType3List: any[] = [];
    isClosingIssue: boolean;
    images: any[];
    showSpinners: boolean = false;

    constructor(public router: Router,
        private modalService: NgbModal,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private settingService: SettingsService,
        private issueWebService: IssueWebService) { }

    ngOnInit() {
        this.images = [];
        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];
                this.loadData(id);

            }
        });
    }

    loadSettings(accounId: number) {
        //let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("IssueType1", accounId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType1 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType2", accounId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType2 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType3", accounId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType3 = response.Data.Value;
                }
            });

    }

    public confirmClicked() {

        //console.log(this.model);
        this.isSending = true;
        // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        //this.model.AccountId = this.currentUser.accountId;
        this.model.Status = 2;
        this.issueWebService.confirm(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.isSending = false;
                this.ngOnInit();
                //this.router.navigate([`/issues`], { relativeTo: this.route }); 
            });

    }

    openAddLog(content, isCloseIssue: boolean) {

        this.isCloseIssue = isCloseIssue;
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        var now = new Date();
        this.issueWebHistoryModel.Date = <NgbDateStruct>{ year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        this.issueWebHistoryModel.Time = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };
        this.issueWebHistoryModel.ReactedBy = "";
        this.modalReference = this.modalService.open(content, modalLarge);

    }

    public closeIssue() {
        this.isCreatingLog = true;
        this.isCloseIssue = true;
        this.isClosingIssue = true;

        this.issueWebHistoryModel.IssueWebId = this.model.IssueWebId;
        this.issueWebService.closeIssue(this.issueWebHistoryModel)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.isSending = false;
                //this.router.navigate([`/issues`], { relativeTo: this.route }); 
                this.ngOnInit();
                this.issueType3List = [];
                this.issueWebHistoryModel = new IssueWebHistory();
                this.modalReference.close();
                this.isCreatingLog = false;
                this.isCloseIssue = false;
                this.isClosingIssue = false;
            });
    };

    public saveLog() {
        this.isCreatingLog = true;
        this.issueWebHistoryModel.IssueWebId = this.model.IssueWebId;

        if (this.issueWebHistoryModel.VisibleToPublic) {
            this.issueWebHistoryModel.IsPrivate = false;
        } else {
            this.issueWebHistoryModel.IsPrivate = true;
        }

        this.issueWebService.saveIssueLog(this.issueWebHistoryModel)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.isSending = false;
                //this.router.navigate([`/issues`], { relativeTo: this.route }); 
                this.issueType3List = [];
                this.ngOnInit();
                this.issueWebHistoryModel = new IssueWebHistory();
                this.modalReference.close();
                this.isCreatingLog = false;
            });
    };

    public getColor(type: string) {
        // 
        var color = "";
        switch (type) {
            case "success":
                color = "green";
                break;

            case "info":
                color = "blue";
                break;

            case "warning":
                color = "orange";
                break;

            case "danger":
                color = "red";
                break;

            case "primary":
                color = "blue";
                break;
        }

        return color;
    }
    public getStatus(type: string) {
        // 
        var color = "";
        switch (type) {
            case "success":
                color = "Closed";
                break;

            case "info":
                color = "Log";
                break;

            case "warning":
                color = "Confirmed";
                break;

            case "danger":
                color = "";
                break;

            case "primary":
                color = "Log";
                break;
        }

        return color;
    }

    public loadData(id: any) {
        this.isLoading = true;
        if (id == undefined) {
            return;
        }

        this.issueWebService.GetByGuid(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.model = response.Data;

                //this.loadTenant();
                this.photoSrc = this.model.Image;
                this.images.push({ source: this.photoSrc, thumbnail: this.model.ImageThumb, title: 'Image' });

                this.isLoading = false;
                this.loadSettings(this.model.AccountId);

                if (this.model.Status == 2) {
                    this.IsConfirmed = true;
                }

                if (this.model.Status == 3) {
                    this.isCloseIssue = true;
                }

                if (this.model.Status != 0 && this.model.Status != 1) {
                    this.IsConfirmed = true;
                    //this.router.navigate([`/login`], { relativeTo: this.route }); 
                }

                //  this.toastr.success(response.Message, "Success"); 
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/issue-web/component/issue-action/issue-action.component.ts